export const GET_ALL_GROUPS_START = 'GET_ALL_GROUPS_START';
export const GET_ALL_GROUPS_SUCCESS = 'GET_ALL_GROUPS_SUCCESS';
export const GET_ALL_GROUPS_ERROR = 'GET_ALL_GROUPS_ERROR';
export const GET_ALL_GROUPS_END = 'GET_ALL_GROUPS_END';
